import { Dimensions, PixelRatio } from 'react-native';
import Device from 'react-native-device-info';
import ThemeProvider from 'states/context/providers/ThemeProvider';
import Configs from 'utils/Configs';

const { width, height } = Dimensions.get('window');

const isTablet = Device.isTablet();

// 375 iphone 6
const min = Math.min(width, height);
let scale = min / 375 < 1.5 ? min / 375 : 1.5;
let initFontSize = scale > 1 ? 15 : 14;

// Nếu ipad. thì thu nhỏ text đi một tý nữa
if (isTablet) {
  scale = scale < 1.3 ? scale : 1.3;
  initFontSize = 14;
}

// Tinh font size
const FIX_FONT_SIZE = initFontSize * scale;
const DRAWER_WIDTH = PixelRatio.roundToNearestPixel(scale * 280);

const UIConst = {
  changeFontSize: () => {
    UIConst.FONT_SIZE = FIX_FONT_SIZE + (Configs.settings.fontSizeType - 2) * 2;
    ThemeProvider.instance?.setState({ fontSizeType: Configs.settings.fontSizeType });
  },

  WIDTH: width,
  HEIGHT: height,
  SCALE: scale,
  DRAWER_WIDTH,
  FONT_SIZE: FIX_FONT_SIZE,
  FIX_FONT_SIZE,
  MAX_WIDTH: width - 40 > 400 ? 400 : width - 40,
  LOGO_STYLE: {
    width: 90 * scale,
    height: 90 * scale
  }
};

export default UIConst;
